webpackJsonp([55702396619907],{

/***/ 363:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"group":[{"fieldValue":"brewing","totalCount":1},{"fieldValue":"chemex","totalCount":1},{"fieldValue":"flavor","totalCount":1},{"fieldValue":"intro","totalCount":1},{"fieldValue":"tasting","totalCount":1}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-494e91014c9004a0085d.js